import { render, staticRenderFns } from "./AutomationTab.vue?vue&type=template&id=05382916&scoped=true&"
import script from "./AutomationTab.vue?vue&type=script&lang=js&"
export * from "./AutomationTab.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTab.vue?vue&type=style&index=0&id=05382916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05382916",
  null
  
)

export default component.exports